@if (cardData != undefined) {
  <div class="_wf-banner-contain">
    <div class="_wf-banner no-corner m-0" [ngClass]="expandCard ? '_wf-banner_expand': ''">
      <div class="_wf-banner-patient-img">
        <img src="assets/webflow-images/icon-patient-default.png" loading="lazy" width="100" alt="" class="image">
      </div>
      <div class="_wf-banner-meta-data">
        <div class="_wf-banner-meta-data__top">
          <div class="_wf-banner-meta-data__top-left" >
            @if (cardData.patient_name != undefined && cardData.patient_name) {
              <div class="_wf-banner-patient-name"
                >
              {{cardData.patient_name}}</div>
            }
            @if (cardData.patient_age != undefined && cardData.patient_gender != undefined) {
              <div class="_wf-banner-text left-space no-space"
                >
                {{cardData.patient_age}} | {{cardData.patient_gender}}
              </div>
            }
            @if (cardData.uhId != undefined) {
              <div class="_wf-banner-text left-space no-space">{{cardData.uhId}}
              </div>
            }
          </div>
        </div>
        <div class="_wf-banner-meta-data__bottom">
          @if (cardData.vulnerable || cardData.vip || cardData.handleWithCare || cardData.complexDiagnosis || cardData.isMLC) {
            <div class="_wf-banner-meta-data__bottom-content-section">
              <div class="_wf-banner-meta-data__top-right__icon-contain">
                @if (cardData.vulnerable) {
                  <img src="assets/images/Vulnerable.png" loading="lazy" width="25"
                    alt="" class="_wf-banner-vip no-space">
                }
                @if (cardData.vip) {
                  <img src="assets/images/VIP.png" loading="lazy" width="25" alt=""
                    class="_wf-banner-vip">
                }
                @if (cardData.handleWithCare) {
                  <img src="assets/images/HandleWithCare.png" loading="lazy"
                    width="25" alt="" class="_wf-banner-vip">
                }
                @if (cardData.complexDiagnosis) {
                  <img src="assets/images/ComplexCare.png" loading="lazy"
                    width="25" alt="" class="_wf-banner-vip">
                }
                @if (cardData.isMLC) {
                  <img src="assets/images/MLC.png" loading="lazy" width="25" alt=""
                    class="_wf-banner-vip">
                }
              </div>
            </div>
          }
          @if (cardData.admittingDoctor !=undefined && cardData.admittingDoctorSpeciality != undefined) {
            <div class="_wf-banner-meta-data__bottom-content-section">
              <div class="_wf-banner-text">Admitting Doctor/ Speciality</div>
              <div class="_wf-banner-text bold">{{cardData.admittingDoctor}}/ {{cardData.admittingDoctorSpeciality}}</div>
            </div>
          }
          @if (cardData.currentWard !=undefined && cardData.currentBed != undefined) {
            <div class="_wf-banner-meta-data__bottom-content-section">
              <div class="_wf-banner-text">Ward/ Bed</div>
              <div class="_wf-banner-text bold">{{cardData.currentWard}}/ {{cardData.currentBed}}</div>
            </div>
          }
          @if (cardData.treatingDoctor !=undefined && cardData.treatingDoctorSpeciality != undefined) {
            <div class="_wf-banner-meta-data__bottom-content-section">
              <div class="_wf-banner-text">Treating Doctor/ Speciality</div>
              <div class="_wf-banner-text bold">{{cardData.treatingDoctor}}/ {{cardData.treatingDoctorSpeciality}}</div>
            </div>
          }
          @if (cardData.identifier != undefined) {
            <div class="_wf-banner-meta-data__bottom-content-section">
              <div class="_wf-banner-text">Admission No.</div>
              <div class="_wf-banner-text bold">{{cardData.identifier}}</div>
            </div>
          }
          @if (cardData.admissionId != undefined) {
            <div class="_wf-banner-meta-data__bottom-content-section">
              <div class="_wf-banner-text">Admission No.</div>
              <div class="_wf-banner-text bold">{{cardData.admissionId}}</div>
            </div>
          }
          @if (cardData.payer_type !=undefined || cardData.payer_name !=undefined) {
            <div class="_wf-banner-meta-data__bottom-content-section">
              <div class="_wf-banner-text">Payer</div>
              <div class="_wf-banner-text bold">{{cardData.payer_type}}/{{cardData.payer_name}}</div>
            </div>
          }
          @if (cardData.payer_group !=undefined || cardData.payer_sub_group !=undefined) {
            <div class="_wf-banner-meta-data__bottom-content-section">
              <div class="_wf-banner-text">Payer Group</div>
              <div class="_wf-banner-text bold">{{cardData.payer_group }}/{{cardData.payer_sub_group}}</div>
            </div>
          }
        </div>
      </div>
      <div class="_wf-banner-three-dots" style="margin-top: 20px;">
        <ng-container *ngIf="extra_buttons">
          <ng-template #extraBtnTemplate let-btn="btn" let-data="data">
            <div class="showTat">
              <div class="total-text-container additional-details-popup">
                <div class="d-flex flex-column">
                  <ng-container *ngFor="let field of btn.fields">
                    <div class="total-text-container d-flex" style="margin-left: 20px;">
                      <div class="employee-label">
                        <b>{{ field.label }}</b>
                      </div>
                      <div class="employee-col">:</div>
                      <div class="employee-rel">
                        {{getFieldValue(cardData, field)}}
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-container *ngFor="let btn of extra_buttons">
            <button class="btn-with-icon-label buttons-icon" type="button" *ngIf="!utilService.isMobile() && btn.action_name" (click)="extraButtonClick(btn)"
              #contextMenu="bs-popover" [popover]="btn.showPopover ? extraBtnTemplate : null"
              placement="left top" container="body" containerClass="tabelcontextualmenu card-contextual-menu"
              [outsideClick]="true" [popoverContext]="{ btn: btn, data: cardData }" >
              <i class="fa" [ngClass]="btn.fa_icon ? btn.fa_icon : ''">
              <img *ngIf="btn.icon" [src]="btn.icon" class="btn-icon nav-icon nav-img-icon"></i>
              <span class="btn-label">{{btn.label}}</span>
            </button>
          </ng-container>
        </ng-container>
      </div>
    </div>
    @if (utilService.isMobile() ? expandCard : true) {
      <div class="_wf-supporting-banner-contain m-0">
        <div class="_wf-supporting-banner-contain__left w-100">
          <div class="_wf-supporting-banner-contain__left-bottom">
            @if (cardData.bill_no != undefined && cardData.bill_no != '') {
              <div class="_wf-banner-meta-data__bottom-content-section _16pc">
                <div class="_wf-banner-text">Bill No.</div>
                <div class="_wf-banner-text bold">{{cardData.bill_no}}</div>
              </div>
            }
            @if (cardData.bill_date_time != undefined && cardData.bill_date_time != '') {
              <div class="_wf-banner-meta-data__bottom-content-section _16pc">
                <div class="_wf-banner-text">Bill Date Time</div>
                <div class="_wf-banner-text bold">{{cardData.bill_date_time | date:'short'}}</div>
              </div>
            }
            @if (cardData.currentBillingCategory !=undefined) {
              <div class="_wf-banner-meta-data__bottom-content-section _16pc">
                <div class="_wf-banner-text">Bill category</div>
                <div class="_wf-banner-text bold">{{cardData.currentBillingCategory}}</div>
              </div>
            }
            @if (cardData.bill_amount != undefined) {
              <div class="_wf-banner-meta-data__bottom-content-section _16pc">
                <div class="_wf-banner-text">Bill Amount</div>
                <div class="_wf-banner-text bold">{{cardData.bill_amount}}</div>
              </div>
            }
            @if (cardData.discount !=undefined) {
              <div class="_wf-banner-meta-data__bottom-content-section _16pc">
                <div class="_wf-banner-text">Discount</div>
                <div class="_wf-banner-text bold">{{cardData.discount}}</div>
              </div>
            }
            @if (cardData.total_amount !=undefined) {
              <div class="_wf-banner-meta-data__bottom-content-section _16pc">
                <div class="_wf-banner-text">Net Amount</div>
                <div class="_wf-banner-text bold">{{cardData.total_amount}}</div>
              </div>
            }
            @if (cardData.patient_amount !=undefined) {
              <div class="_wf-banner-meta-data__bottom-content-section _16pc">
                <div class="_wf-banner-text">Patient Amount</div>
                <div class="_wf-banner-text bold">{{cardData.patient_amount}}</div>
              </div>
            }
            @if (cardData.deposite_amount !=undefined) {
              <div class="_wf-banner-meta-data__bottom-content-section _16pc">
                <div class="_wf-banner-text">Paid Amount</div>
                @if (cardData.deposite_amount && !cardData.paid_amount) {
                  <div class="_wf-banner-text bold">{{cardData.deposite_amount}}</div>
                }
                @if (cardData.paid_amount) {
                  <div class="_wf-banner-text bold">{{cardData.paid_amount}}</div>
                }
              </div>
            }
            @if (cardData.payer_amount !=undefined && cardData.payer_type != 'cash') {
              <div class="_wf-banner-meta-data__bottom-content-section _16pc">
                <div class="_wf-banner-text">Payer Amount</div>
                <div class="_wf-banner-text bold">{{cardData.payer_amount}}</div>
              </div>
            }
            @if (cardData.payment_type == 'credit' && cardData.payer_type != 'cash') {
              <div class="_wf-banner-meta-data__bottom-content-section _16pc">
                <div class="_wf-banner-text">Authorised Amount</div>
                <div class="_wf-banner-text bold">{{cardData.authorized_amount}}</div>
              </div>
            }
            @if (cardData.patient_due_amount !=undefined && cardData.patient_due_amount >= 0) {
              <div class="_wf-banner-meta-data__bottom-content-section _16pc">
                <div class="_wf-banner-text" [class._pb-due-amount-red]="cardData.patient_due_amount > 0">Due Amount</div>
                <div class="_wf-banner-text bold" [class._pb-due-amount-red]="cardData.patient_due_amount > 0">{{cardData.patient_due_amount}}</div>
              </div>
            }
            @if (cardData.patient_due_amount !=undefined && cardData.patient_due_amount < 0) {
              <div class="_wf-banner-meta-data__bottom-content-section _16pc">
                <div class="_wf-banner-text">Refund Amount</div>
                <div class="_wf-banner-text bold">{{cardData.refundable}}</div>
              </div>
            }
              <!-- @if (cardData.netAmount != undefined && cardData.netAmount != '') {
              <div class="_wf-banner-meta-data__bottom-content-section _16pc">
                <div class="_wf-banner-text _bold-highlight-color">Available Cash Amount</div>
                <div class="_wf-banner-text _bold-highlight-color">{{cardData.netAmount}}</div>
              </div>
            } -->
          </div>
        </div>
      </div>
    }
    <div class="_wf-expand-banner-contain" (click)="expandCards();">
      @if (!expandCard) {
        <img src="assets/webflow-images/icon-card-more-reverse.svg" loading="lazy" alt="">
      }
      @if (expandCard) {
        <img src="assets/webflow-images/icon-card-less-reverse.svg" loading="lazy" alt="">
      }
      @if (!expandCard) {
        <i class="fa fa-caret-down" style="line-height: 13px;" ></i>
      }
      @if (expandCard) {
        <i class="fa fa-caret-up" style="line-height: 14px;"></i>
      }
    </div>
  </div>
}
